import React from 'react';
import styled from 'styled-components';
import { media } from '../styles/breakpoints';

const Container = styled.div`
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    padding-top: 56%;
    width: 90vw;
    max-width: 1200px;
    max-height: 550px;
    
    ${media.tweak900up`
        padding-top: 43%;
        font-size: 0.9em;
    `}
    ${media.tweak600up`
        padding-top: 56%;
        font-size: 0.8em;
    `}

    & iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
    }

    & .container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
    }

    & .consent {
      background-color: rgb(250, 250, 250);
      position: absolute;
      top: 2em;
      left: 0;
      z-index: 99;
      opacity: 0.9;
      width: 100%;
      height: 8em;
      padding: 1em 1em;
      text-align: center;

      ${media.tweak900up`height: 10em;`}
      ${media.tweak600up`height: 12em;`}
    }

    & .schnoffle-button-small {
          ${props => props.theme.typography.button};
          padding: 0.5em 0.6em;
          min-width: 72px;
          font-size: 0.8125rem;
          min-height: 2em;
          color: white;
          margin-top: 0.65em;
    }
`;

const IframeContainer = ({ children }) =>
    <Container>{children}</Container>;

export default IframeContainer;



// WEBPACK FOOTER //
// ./src/components/home/IframeContainer.js